/*
  merch_promo — prev/next arrows step the slider one slide at a time.
  Binds every [data-merch-slider] on the page; re-binds in the theme editor.
*/
(function () {
  function init(slider) {
    if (slider.dataset.merchReady === 'true') return;
    slider.dataset.merchReady = 'true';

    var track = slider.querySelector('[data-merch-track]');
    var prev = slider.querySelector('[data-merch-prev]');
    var next = slider.querySelector('[data-merch-next]');
    if (!track || !prev || !next) return;

    function go(direction) {
      var reduced =
        window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollBy({
        left: direction * track.clientWidth,
        behavior: reduced ? 'auto' : 'smooth'
      });
    }

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      prev.disabled = max <= 1 || track.scrollLeft <= 1;
      next.disabled = max <= 1 || track.scrollLeft >= max - 1;
    }

    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if (typeof ResizeObserver === 'function') new ResizeObserver(update).observe(track);
    update();
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-merch-slider]').forEach(init);
  }

  initAll();
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
